import PropTypes from 'prop-types';

import { Link } from 'react-router';

import { connect } from 'react-redux';

import { Button } from 'Components/LegacyButton';

import { getIsAuthenticated, getIsAuthenticating } from 'dux/auth/selectors';
import * as userSelectors from 'dux/user/selectors';

const LandingPageCTA = ({
  dataClick: dataCLickProp,
  dataFrom,
  isAuthenticated,
  isAuthenticating,
  productLabel,
  hasCompletedHaircareConsultation,
  theme,
  variant,
  ...props
}) => {
  if (isAuthenticating) {
    return null;
  }

  const to =
    isAuthenticated && hasCompletedHaircareConsultation
      ? '/checkout/haircare'
      : isAuthenticated && !hasCompletedHaircareConsultation
      ? '/consultation'
      : '/consultation/haircare/signin';
  const label = isAuthenticated ? `Order your ${productLabel}` : `Get your ${productLabel}`;
  const dataClick = isAuthenticated ? dataCLickProp : 'signin';

  return (
    <Button
      Component={Link}
      data-click={dataClick}
      data-from={dataFrom}
      to={to}
      variant={variant ?? theme}
      {...props}
    >
      {label}
    </Button>
  );
};

LandingPageCTA.propTypes = {
  dataClick: PropTypes.string,
  dataFrom: PropTypes.string,
  hasCompletedHaircareConsultation: PropTypes.bool,
  isAuthenticated: PropTypes.bool.isRequired,
  isAuthenticating: PropTypes.bool.isRequired,
  productLabel: PropTypes.string.isRequired,
  /**
   * @deprecated
   * please use variant instead.
   */
  theme: PropTypes.string,
  variant: PropTypes.string,
};

LandingPageCTA.defaultProps = {
  dataClick: null,
  dataFrom: null,
  hasCompletedHaircareConsultation: false,
  /**
   * @deprecated
   * please use variant instead.
   */
  theme: 'vert',
  variant: null,
};

const mapStateToProps = state => ({
  isAuthenticated: getIsAuthenticated(state),
  isAuthenticating: getIsAuthenticating(state),
  hasCompletedHaircareConsultation: userSelectors.getHasCompletedHaircareConsultation(state),
});

export default connect(mapStateToProps, {})(LandingPageCTA);
